import { Link, Paragraph } from '@customerio/pluma-components/react';
import snowflakeLogo from '@/assets/images/integrations/snowflake.svg';
import { ConnectorLanding } from './components/connector-landing';
import type { WarehouseLandingPageProps } from './types';

export default function SnowflakePage({ workspaceId, sync, showPremiumLabel }: WarehouseLandingPageProps) {
  return (
    <ConnectorLanding
      workspaceId={workspaceId}
      sync={sync}
      showPremiumLabel={showPremiumLabel}
      logoSrc={snowflakeLogo}
      title="Snowflake"
      blurb="Snowflake is a cloud-based data storage and analytics service, providing secure and easy access to any data with near-infinite scalability."
      ingestStep={
        <Paragraph size="xs" color="subtle" mt="050" mb="200">
          There are many approaches to this, but typically requires a COPY INTO command to load the parquet files from
          your bucket. Once loaded, set an expiration on the parquet files so they get automatically deleted.{' '}
          <Link href="https://docs.snowflake.com/en/user-guide-data-load.html" variant="secondary" isExternal={true}>
            View Snowflake&apos;s documentation
          </Link>{' '}
          on loading data into Snowflake.
        </Paragraph>
      }
    />
  );
}
